// import { useState } from "react";
// import DashboardLayout from "../../components/DashboardLayout";
// import Stepper from "../../components/Common/Stepper";
// // import WalletProfileInfo from "../../components/Wallet/WalletInfo";
// import PinSetup from "../../components/Wallet/PinSetup";
// import BankLinking from "../../components/Wallet/BankLinking";
// import WalletSummary from "../../components/Wallet/WalletSummary";
// import WalletSuccessModal from "../../components/Wallet/WalletSuccessModal";
// import { useNavigate } from "react-router";
// import { useCreateWalletMutation } from "../../redux/services/Wallet";

// const WalletSetup = () => {
//   const steps = ["Bank Details", "PIN Setup", "Confirm"];
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const navigate = useNavigate();

//   const [currentStep, setCurrentStep] = useState(0);

//   const [formData, setFormData] = useState({
//     businessName: "",
//     walletDisplayName: "",
//     businessType: "",
//     country: "",
//     currency: "",
//   });

//   const [pinData, setPinData] = useState({
//     newPin: "",
//     confirmNewPin: "",
//   });

//   const [bankData, setBankData] = useState({
//     accountName: "",
//     bankName: "",
//     bankCode: "",
//     accountNumber: "",
//     bvn: "",
//   });

//   const [createWallet, { isLoading }] = useCreateWalletMutation();

//  const handleInputChange = (
//    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any
//  ) => {
//    const { name, value } = e.target;

//    if (name === "bankData" && typeof value === "object") {
//      // ✅ Update both bankName and bankCode together
//      setBankData((prev) => ({
//        ...prev,
//        bankName: value.bankName,
//        bankCode: value.bankCode,
//      }));
//    } else if (name in formData) {
//      setFormData({ ...formData, [name]: value });
//    } else if (name in pinData) {
//      setPinData({ ...pinData, [name]: value });
//    } else if (name in bankData) {
//      setBankData({ ...bankData, [name]: value });
//    }
//  };


//   const handleStepChange = (step: number) => {
//     setCurrentStep(step);
//   };

//   const handleConfirm = async () => {
//     try {
//       const res = await createWallet({
//         bvn: bankData.bvn,
//         pin_hashed: pinData.newPin, // You can hash it before sending if needed
//         preferred_account_number: bankData.accountNumber,
//         preferred_bank_name: bankData.bankName,
//         account_name: bankData.accountName,
//       }).unwrap();

//       console.log("✅ Wallet created:", res);

//       if (res.status === "success") {
//         setShowSuccessModal(true) // open success modal
//       }
//     } catch (err) {
//       console.error("❌ Wallet creation failed:", err);
//     }
//   };

//   return (
//     <>
//       <WalletSuccessModal
//         isOpen={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//         onGoToWallet={() => {
//           setShowSuccessModal(false);
//           // Navigate to wallet overview
//           navigate("/wallet");
//         }}
//       />
//       <DashboardLayout
//         title="Set Up Wallet"
//         description="Let’s get started"
//         containerClass="space-y-10"
//       >
//         <div className="w-full sm:max-w-4xl mx-auto">
//           <Stepper
//             steps={steps}
//             currentStep={currentStep}
//             onStepChange={handleStepChange}
//           />
//         </div>
//         <div className="mb-10">
//           {/* Step-wise Rendering of Components */}
//           {/* {currentStep === 0 && (
//             <WalletProfileInfo
//               formData={formData}
//               handleInputChange={handleInputChange}
//               onNext={() => setCurrentStep(1)}
//             />
//           )} */}

//           {currentStep === 0 && (
//             <BankLinking
//               bankData={bankData}
//               handleInputChange={handleInputChange}
//               onNext={() => setCurrentStep(1)}
//             />
//           )}
//           {currentStep === 1 && (
//             <PinSetup
//               pinData={pinData}
//               handleInputChange={handleInputChange}
//               onBack={() => setCurrentStep(0)}
//               onNext={() => setCurrentStep(2)}
//             />
//           )}
//           {currentStep === 2 && (
//             <WalletSummary
//               formData={formData}
//               pinData={pinData}
//               bankData={bankData}
//               isLoading={isLoading}
//               onBack={() => setCurrentStep(1)}
//               onConfirm={() => handleConfirm()}
//             />
//           )}
//         </div>
//       </DashboardLayout>
//     </>
//   );
// };
// export default WalletSetup;



import { useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import Stepper from "../../components/Common/Stepper";
import PinSetup from "../../components/Wallet/PinSetup";
import BankLinking from "../../components/Wallet/BankLinking";
import WalletSummary from "../../components/Wallet/WalletSummary";
import WalletSuccessModal from "../../components/Wallet/WalletSuccessModal";
import { useNavigate } from "react-router";
import { useCreateWalletMutation } from "../../redux/services/Wallet";
import { toast } from "sonner";

const WalletSetup = () => {
  const steps = ["Bank Details", "PIN Setup", "Confirm"];
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // Read off createWallet's response — a final confirmation of the same
  // name shown during BVN verification, no need to re-verify for it.
  const [confirmedBvnName, setConfirmedBvnName] = useState<string | null>(null);
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(0);

  const [formData, setFormData] = useState({
    businessName: "",
    walletDisplayName: "",
    businessType: "",
    country: "",
    currency: "",
  });

  const [pinData, setPinData] = useState({
    newPin: "",
    confirmNewPin: "",
  });

  const [bankData, setBankData] = useState({
    accountName: "",
    bankName: "",
    bankCode: "",
    accountNumber: "",
    bvn: "",
  });

  const [createWallet, { isLoading }] = useCreateWalletMutation();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any
  ) => {
    const { name, value } = e.target;

    if (name === "bankData" && typeof value === "object") {
      setBankData((prev) => ({
        ...prev,
        bankName: value.bankName,
        bankCode: value.bankCode,
      }));
    } else if (name in formData) {
      setFormData({ ...formData, [name]: value });
    } else if (name in pinData) {
      setPinData({ ...pinData, [name]: value });
    } else if (name in bankData) {
      // BVN — strip non-digits and cap at 11 characters
      if (name === "bvn") {
        const digitsOnly = value.replace(/\D/g, "").slice(0, 11);
        setBankData({ ...bankData, bvn: digitsOnly });
        return;
      }
      setBankData({ ...bankData, [name]: value });
    }
  };

  const handleStepChange = (step: number) => {
    setCurrentStep(step);
  };

  // Validate step 0 (Bank Details) before proceeding
  const handleBankDetailsNext = () => {
    if (!bankData.bvn) {
      toast.error("BVN is required.");
      return;
    }
    if (!/^\d{11}$/.test(bankData.bvn)) {
      toast.error("BVN must be exactly 11 digits.");
      return;
    }
    if (!bankData.accountNumber) {
      toast.error("Account number is required.");
      return;
    }
    if (!bankData.bankName) {
      toast.error("Please select a bank.");
      return;
    }
    setCurrentStep(1);
  };

  const handleConfirm = async () => {
    try {
      const res = await createWallet({
        bvn: bankData.bvn,
        pin_hashed: pinData.newPin,
        preferred_account_number: bankData.accountNumber,
        preferred_bank_name: bankData.bankName,
        account_name: bankData.accountName,
      }).unwrap();

      console.log("✅ Wallet created:", res);

      if (res.status === "success") {
        // Shape isn't pinned down — bvn_details has shown up nested under
        // `data` and at the top level depending on the endpoint, so check both.
        const bvnDetails = (res as any)?.data?.bvn_details ?? (res as any)?.bvn_details;
        setConfirmedBvnName(bvnDetails?.account_name ?? bvnDetails?.name ?? null);
        setShowSuccessModal(true);
      }
    } catch (err: any) {
      console.error("❌ Wallet creation failed:", err);
      const errorMsg =
        err?.data?.error?.message ||
        err?.data?.message ||
        err?.data?.error ||
        err?.data?.errors?.bvn?.[0] ||
        err?.data?.errors?.pin_hashed?.[0] ||
        "Wallet creation failed. Please try again.";
      toast.error(typeof errorMsg === "string" ? errorMsg : "Wallet creation failed. Please try again.");
    }
  };

  return (
    <>
      <WalletSuccessModal
        isOpen={showSuccessModal}
        bvnName={confirmedBvnName}
        onClose={() => setShowSuccessModal(false)}
        onGoToWallet={() => {
          setShowSuccessModal(false);
          navigate("/wallet");
        }}
      />
      <DashboardLayout
        title="Set Up Wallet"
        description="Let's get started"
        containerClass="space-y-10"
      >
        <div className="w-full sm:max-w-4xl mx-auto">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onStepChange={handleStepChange}
          />
        </div>
        <div className="mb-10">
          {currentStep === 0 && (
            <BankLinking
              bankData={bankData}
              handleInputChange={handleInputChange}
              onNext={handleBankDetailsNext}
            />
          )}
          {currentStep === 1 && (
            <PinSetup
              pinData={pinData}
              handleInputChange={handleInputChange}
              onBack={() => setCurrentStep(0)}
              onNext={() => setCurrentStep(2)}
            />
          )}
          {currentStep === 2 && (
            <WalletSummary
              formData={formData}
              pinData={pinData}
              bankData={bankData}
              isLoading={isLoading}
              onBack={() => setCurrentStep(1)}
              onConfirm={() => handleConfirm()}
            />
          )}
        </div>
      </DashboardLayout>
    </>
  );
};

export default WalletSetup;